import React from "react";
import { AppleLogo, PlayLogo } from "../landing/StoreBadges";
import { APP_STORE_URL } from "./inviteContent";
import { trackAppStore } from "../../lib/trackAppStore";

export const DownloadButtons = () => (
  <div className="mt-10 border-t border-[#E8EBE9] pt-8" data-testid="invite-download-section">
    <p className="text-sm font-medium text-[#4A5F52]">Not on SisterSafe yet? Download SisterSafe:</p>
    <div className="mt-4 flex flex-col gap-3">
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackAppStore("invite")}
        className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#2F5E43]/20 bg-white px-5 py-3.5 font-semibold text-[#111E16] transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#E4EDE6]"
        data-testid="invite-app-store-btn"
      >
        <AppleLogo className="h-5 w-5" /> App Store (iPhone)
      </a>
      <span
        role="link"
        aria-disabled="true"
        className="flex flex-1 cursor-not-allowed select-none items-center justify-center gap-2 rounded-full border border-[#E8EBE9] bg-[#F1F2F0] px-5 py-3.5 font-semibold text-[#9AA59E]"
        data-testid="invite-google-play-disabled"
      >
        <PlayLogo className="h-5 w-5" /> Google Play
        <span className="rounded-full bg-[#E3E6E4] px-2 py-0.5 text-xs font-medium">Coming Soon</span>
      </span>
    </div>
  </div>
);
